<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="downloadExcel()"
          >下载Excel
          </el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="success"
            icon="el-icon-view"
            size="small"
            plain
            @click.stop="func(scope.row)"
          >查看
          </el-button>

        </template>
      </avue-crud>

    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { shipmentProductOption } from "@/const/salesCloud/shipmentProductOption";
import {
  findShipmentProductList2,
  // productDetail2,
  findShipmentProductList2DownloadExcel,
} from "@/api/salesCloud/shipmentProduct";
import { findByLabel, formatterTime } from "@/util/util";
import { DIC } from "@/const/dic";

export default {
  name: "shipmentProduct",
  data() {
    return {
      tableOption: shipmentProductOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      downloadData: {},
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
      dealerId: this.$route.query.dealerId,
    };
  },
  created() {
    this.handleList();
    // findShop().then((res) =>{
    //     let data = JSON.parse(res.data);
    //     this.distributors=data;
    //
    // })
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      params.dealerId = this.dealerId;
      findShipmentProductList2(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      params.dealerId = this.dealerId;
      findShipmentProductList2(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.dealerId = this.dealerId;
      this.downloadData = params;
      findShipmentProductList2(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      params.dealerId = this.dealerId;
      findShipmentProductList2(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {},
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize,
        dealerId: this.dealerId,
      };
      findShipmentProductList2(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        console.log(this.tableData,22222);
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {},
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {},
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {},
    func(row) {
      this.$router.push({
        name: "出货产品记录",
        path: "/salesCloud/shipmentProductDetail",
        query: {
          dealerId: row.dealerId,
          productId: row.productId,
          skuId: row.skuId,
          price: row.price,
        },
      });
    },
    downloadExcel() {
      let params = this.downloadData;
      params.dealerId = this.dealerId;
      console.log(params);
      findShipmentProductList2DownloadExcel(params).then((res) => {
        if (res.code == "200") {
          window.open(res.data);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
